module.exports = __webpack_public_path__ + "img/join-bg (2).812efe10.jpg";